// extracted by mini-css-extract-plugin
export default {"root":"rBIjxFWRhXNrC3LJfZvK","header":"Cw_ic8jphjC4lEORIXtO","name":"K5QnkSOj3nJOU_oXYBye","surveyGroupSurvey":"xERf5X42kt1UxzeEaIkQ"};